<div [ngClass]="{'drawer':isOpen}" [class.open]="isDrawerOpen">
    <div *ngIf="isOpen" (click)="drawerService.toggleDrawer()" class="row" style="place-content: center;">
        <div class="close-btn">
            <div class="mb-1">×</div>
        </div>
    </div>
    <div [ngClass]="{'promo-card':isOpen}">
        <div [ngClass]="{'promo-message':isOpen}">

            <div>
                <div class="row justify-content-center text-center">
                    <a href="https://home-connect.co.za/terms/" style="color:black"
                        target="_blank">
                        <b> <i> T&Cs Apply.</i></b> </a>
                </div>
                <div style="text-align: center;" [innerHTML]="content">
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isOpen" class="overlay" [class.visible]="isDrawerOpen" (click)="drawerService.toggleDrawer()"></div>